import { getTransationCharges } from '../../../utils/getAmountWithTransaction';

/*
 * What the review page shows. The server works the same numbers out again
 * (backend utils/stayPricing.js) and charges its own — this is only display.
 *
 *   stayAmounts(stay, paymentType) -> { dueNow, fee, payNow, payLater }
 */
export function stayAmounts(stay, paymentType) {
    const total = Number(stay?.pricing?.total || 0);
    const reserve = Number(stay?.pricing?.reserveAmount || 0);
    const dueNow = stay?.isReserved && reserve > 0 ? reserve : total;
    const fee = paymentType === 'UPI' ? 0 : getTransationCharges(dueNow);
    return { dueNow, fee, payNow: dueNow + fee, payLater: Math.max(total - dueNow, 0) };
}
